<template>
  <v-app>
    <v-content>
      <!-- <dark-template-container /> -->
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
// import DarkTemplateContainer from '@/views/dark-template/Container'

export default {
  name      : 'App',
  components: {},
  // components: { DarkTemplateContainer },
  data () {
    return {}
  },
  created () {
    if (this.$router.path !== '/secure' && this.$router.path !== '/login')
      this.$router.replace('/login').catch(() => {})
  },
}
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
} */
</style>
